
// layout.component.ts

import { Component } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { SidebarComponent } from './sidebar/sidebar.component';
import { TopbarComponent } from './topbar/topbar.component';
import { FooterComponent } from './footer/footer.component';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [
    MatSidenavModule,
    RouterModule,
    SidebarComponent,
    TopbarComponent,
    FooterComponent,
  ],
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent {
  isMobile: boolean = false;
  sidebarMode: 'side' | 'over' = 'side';
  sidebarOpened: boolean = true;

  constructor(private breakpointObserver: BreakpointObserver) {
    this.breakpointObserver
      .observe([Breakpoints.Handset])
      .subscribe((result) => {
        this.isMobile = result.matches;
        if (this.isMobile) {
          this.sidebarMode = 'over';
          this.sidebarOpened = false;
        } else {
          this.sidebarMode = 'side';
          this.sidebarOpened = true;
        }
      });
  }

  toggleSidebar() {
    this.sidebarOpened = !this.sidebarOpened;
  }
}

